// Merkan · Starter des Assistenten unten rechts
// Zusammengeklappt als schmale Leiste "Assistent fragen". Mit X beendet wird daraus ein rundes Symbol,
// das weiterhin unten rechts bleibt. Ein Klick auf beides öffnet das Fenster.
import { IcSchliessen as X } from '../../ui/icons';
import { IcKiAssistent } from '../../ui/icons';
import './assistent.css';
import { t } from '../../lib/sprache';

export type StarterArt = 'leiste' | 'symbol';

export default function Starter({ art, oeffnen, beenden }: { art: StarterArt; oeffnen: () => void; beenden: () => void }) {
  if (art === 'symbol') {
    return (
      <button type="button" className="as-starter-symbol nicht-drucken" onClick={oeffnen} title={t('{ki} öffnen')} aria-label={t('{ki} öffnen')}>
        <IcKiAssistent />
      </button>
    );
  }
  return (
    <div className="as-starter nicht-drucken">
      <button type="button" className="as-starter-knopf" onClick={oeffnen} aria-label={t('{ki} öffnen')}>
        <span className="as-marke"><IcKiAssistent /></span>
        <span className="as-starter-text">{t('{ki} fragen')}</span>
      </button>
      <button type="button" className="as-starter-x" onClick={beenden} title={t('Beenden')} aria-label={t('{ki} ausblenden')}><X size={14} /></button>
    </div>
  );
}
